import Lenis from 'lenis'
import { initFeaturesTabsParallax } from './features-tabs-parallax'

export function initSmoothScroll() {
	const lenis = new Lenis({
		duration: 1.5,
		smoothWheel: true,
	})

	function raf(time) {
		lenis.raf(time)
		requestAnimationFrame(raf)
	}

	requestAnimationFrame(raf)

	initFeaturesTabsParallax(lenis)
}
